import React from 'react';
import {
  formatSimpleInOutEpochShort,
  simpleInOutStatusLabel,
  useMySimpleInOutStatus,
} from './useMySimpleInOutStatus';

/**
 * Home's one-click dot on desktop: In shows "Dot out", every other status
 * (Busy included) shows "Dot in". Leaving HQ is dotted Out by the geofence, so
 * the manual step back from Busy is usually In. Phones keep the Home card.
 */
export default function SimpleInOutDotToggle() {
  const sio = useMySimpleInOutStatus();
  if (!sio.visible || !sio.loaded) return null;

  const isIn = sio.currentStatus === 'in';
  const target = isIn ? 'out' : 'in';
  const label = isIn ? 'Dot out' : 'Dot in';
  const current = simpleInOutStatusLabel(sio.currentStatus);

  return (
    <button
      type="button"
      className="btn btn-outline ui-tooltip ui-tooltip--below simple-inout-dot-toggle"
      data-tooltip={`Now ${current} · updated ${formatSimpleInOutEpochShort(sio.updatedAt)}`}
      aria-label={`Simple I/O: you are ${current}. ${label}`}
      disabled={sio.pending}
      onClick={() => sio.setStatus(target)}
    >
      <span className="simple-inout-dot-toggle__dot" data-status={target} aria-hidden="true" />
      {label}
    </button>
  );
}
